import { ajax } from 'rxjs/observable/dom/ajax';
import { defer } from 'rxjs/observable/defer';
import { catchError } from 'rxjs/operators/catchError';
import { switchMap } from 'rxjs/operators/switchMap';
import { AuthService } from '../../services';

/**
  Create default headers object to inject on all endpoint calls
  @returns {Object}
*/
const defaultHeaders = () => {
  let headers = {};
  const t = AuthService.getToken();
  if (t && t.access_token) {
    headers = {
      ...headers,
      Authorization: `Bearer ${t.access_token}`
    }
  }
  return headers;
};

const setSettings = (settings) => {
  settings.headers = { ...settings.headers, ...defaultHeaders() };
  settings.withCredentials = true
  return settings;
}

/**
  Run an ajax call with the default headers and handle refresh token if needed
  @param {Object} settings Settings to send to the ajax call
  @param {Object} store Redux store
  @returns {Observable}
*/
export default (settings, store) =>
  defer(() => {
    return ajax(setSettings(settings)).pipe(
      catchError((error, caught) => {
        if (error.status === 401 && error.response.error === 'invalid_token') {
          return AuthService.authenticateFromTokenShared()
            .pipe(
              switchMap(() => ajax(setSettings(settings))),
              catchError(() => { throw(error) })
            )
        }
        throw(error);
      })
    );
  });



// WEBPACK FOOTER //
// ./src/utils/ajax/index.js